import React from 'react';
import { SponsorBanner } from '@/components/SponsorBanner';

/**
 * PageSideRail — right-hand sponsor column used across main pages (mirrors the Forum).
 * lg+: always-reserved 288px column. Mobile: stacks below page content (parent is flex-col lg:flex-row).
 */
const SLOT2_BASE = { course: 'courses-descriptor' };

export default function PageSideRail({ placement, children, below, className = '' }) {
  const base = placement.split(':')[0];
  const placement2 = `${SLOT2_BASE[base] || base}-2`;
  return (
    <aside
      data-testid="page-side-rail"
      className={`w-full lg:w-72 flex-shrink-0 flex flex-col gap-4 ${className}`}
    >
      {children}
      <SponsorBanner placement={placement} type="side" />
      {below}
      <SponsorBanner placement={placement2} type="side" />
    </aside>
  );
}
